import React from 'react'
import { makeStyles } from '@material-ui/styles'
import DazzedHeading24 from 'components/common/text/DazzedHeading24'
import { useTranslation } from 'react-i18next'
import DazzedParagraph16 from 'components/common/text/DazzedParagraph16'
import GrinButton from 'components/common/buttons/GrinButton/GrinButton'

const useStyles = makeStyles(() => ({
  container: {
    position: 'absolute',
    left: '15%',
    top: '40%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999
  },
  title: {
    color: 'var(--text-color-11)'
  },
  description: {
    marginTop: 20,
    whiteSpace: 'pre'
  },
  backButton: {
    marginTop: 20
  },
  closeButton: {
    marginTop: 20
  }
}))

const VideoEndedMessage = ({ onCloseClicked = () => {} }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <DazzedHeading24 className={classes.title}>
        {t('pages.patients.patientSidebar.items.liveCalls.meetingEndedMessage.title')}
      </DazzedHeading24>
      <DazzedParagraph16 className={classes.description}>
        {t('pages.patients.patientSidebar.items.liveCalls.meetingEndedMessage.description')}
      </DazzedParagraph16>
      <GrinButton
        label={t('general.close')}
        onClick={onCloseClicked}
        mainButtonId="live-call-ended-close"
        className={classes.closeButton}
      />
    </div>
  )
}

export default VideoEndedMessage
